(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
var loadRecentlyViewedProducts = function() {
  // Look for an element with class 'recently-viewed-products'
  var recentlyViewedSection = document.querySelector(".recently-viewed-products");
  if (recentlyViewedSection === null) { return; }
  
  // Get product handles from localStorage
  var recentProducts = [];
  try {
    var stored = localStorage.getItem('theme.recent_products_v3');
    if (stored) {
      recentProducts = JSON.parse(stored);
    }
  } catch(e) {}
  
  if (recentProducts.length === 0) { return; }
  
  // Extract product handles
  var productHandles = [];
  var excludeHandles = [];
  
  // Get exclude handles from data attribute
  var excludeValue = recentlyViewedSection.dataset.exclude;
  if (excludeValue) {
    excludeHandles = excludeValue.split(',').map(function(h) { return h.trim(); });
  }
  
  // Get grid setting from data attribute (products per row)
  var gridNum = recentlyViewedSection.dataset.grid || '4';
  var maxProducts = parseInt(gridNum, 10); // Show same number as products per row
  
  // Collect product handles, excluding current product and excluded handles
  for (var i = recentProducts.length - 1; i >= 0 && productHandles.length < maxProducts; i--) {
    var item = recentProducts[i];
    var handle = item.handle;
    
    // Skip if no handle or excluded
    if (!handle || excludeHandles.indexOf(handle) !== -1) continue;
    
    // Skip if already added
    if (productHandles.indexOf(handle) !== -1) continue;
    
    productHandles.push(handle);
  }
  
  if (productHandles.length === 0) { return; }
  
  // Build search query with product handles (converted to search format)
  var searchTerms = [];
  for (var i = 0; i < productHandles.length; i++) {
    searchTerms.push('handle:' + productHandles[i]);
  }
  
  // Get section settings
  var showVendor = recentlyViewedSection.dataset.showVendor || 'false';
  
  // Build request URL using search with product handles
  var searchQuery = searchTerms.join(' OR ');
  var requestUrl = '/search?view=recently-viewed&type=product&q=' + encodeURIComponent(searchQuery) + '&grid=' + gridNum + '&show_vendor=' + showVendor;
  
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var productsHtml = request.response;
      if (productsHtml && productsHtml.trim() !== '') {
        var carouselContainer = recentlyViewedSection.querySelector('.js-related-product-carousel');
        if (carouselContainer) {
          // Parse the returned HTML
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = productsHtml;
          var productBlocks = tempDiv.querySelectorAll('.product-block');
          
          // Reorder products based on productHandles array (most recent first)
          var orderedHtml = '';
          for (var i = 0; i < productHandles.length; i++) {
            var handle = productHandles[i];
            for (var j = 0; j < productBlocks.length; j++) {
              var block = productBlocks[j];
              if (block.getAttribute('data-product-handle') === handle) {
                orderedHtml += block.outerHTML;
                break;
              }
            }
          }
          
          // Insert ordered products into carousel container
          carouselContainer.innerHTML = orderedHtml;
          
          // Show the section
          recentlyViewedSection.style.display = '';

          theme.peekCarousel.init(
            recentlyViewedSection,
            $('.js-related-product-carousel', recentlyViewedSection),
            '.productRecommendations',
            function() {
              return $(window).width() < 768
            },
            false
          );
        }
      }
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].recently-viewed-products')) {
    loadRecentlyViewedProducts();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].recently-viewed-products')) {
    theme.peekCarousel.destroy(
      $('.recently-viewed-products', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recently viewed products on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadRecentlyViewedProducts();
});

  } catch(e) { console.error(e); }
})();
})();
